"use strict";
exports.__esModule = true;
exports.LinearProgress = exports.CircularProgress = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
exports.LinearProgress = core_1.LinearProgress;
var react_1 = tslib_1.__importDefault(require("react"));
function CircularProgress(props) {
    var rest = tslib_1.__rest(props, []);
    return react_1["default"].createElement(core_1.CircularProgress, tslib_1.__assign({}, rest));
}
exports.CircularProgress = CircularProgress;
//# sourceMappingURL=Progress.js.map